import React from 'react';
import SmartLink from '../Button/SmartLink';
import Link from 'next/link';
import Image from 'next/legacy/image';
import { StaticImageData } from 'next/image';

type ResourceProps = {
  title: string;
  description: string;
  href: string;
  imageSrc: StaticImageData;
};

function ResourceBlock({ title, description, href, imageSrc }: ResourceProps) {
  return (
    <div className="relative m-2 overflow-hidden rounded-lg shadow-lg sm:m-auto">
      <div className="relative h-32">
        <SmartLink href={href}>
          <Image src={imageSrc} alt={title} layout="fill" objectFit="cover" />
        </SmartLink>
      </div>
      <div className="flex flex-col justify-between flex-1 px-6 py-2 bg-white">
        <div className="flex-1">
          <Link href={href} className="block mt-2 no-underline">
            <p className="text-sm font-semibold text-gray-900 capitalize overflow-hidden overflow-ellipsis h-10">
              {title}
            </p>
            <p className="text-xs text-gray-500 overflow-hidden overflow-ellipsis h-16">
              {description}
            </p>
          </Link>
          <div className="mt-3">
            <Link
              href={href}
              className="text-base font-semibold text-primary hover:text-primary-500 no-underline"
            >
              Learn more &rarr;
            </Link>
          </div>
        </div>
      </div>
      <SmartLink href={href} className="absolute inset-0"></SmartLink>
    </div>
  );
}

export default ResourceBlock;
